var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg400MlE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095DF",
    d: "M31 9v35l-2 3H3l-1-2-1-2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    d: "M38.214 11.436h-5.786V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v40.681a5.793 5.793 0 0 0 5.786 5.787h20.855a5.793 5.793 0 0 0 5.787-5.787v-5.786h5.786A5.793 5.793 0 0 0 44 31.11V17.223a5.793 5.793 0 0 0-5.786-5.787zm-8.1-2.966h-5.787a1.158 1.158 0 0 0 0 2.315h5.787v31.896a3.477 3.477 0 0 1-3.473 3.473H5.786a3.477 3.477 0 0 1-3.472-3.473V10.785h15.07a1.158 1.158 0 1 0 0-2.315H2.313V2.467h27.8V8.47zM41.686 31.11a3.477 3.477 0 0 1-3.472 3.472h-5.786v-20.83h5.786a3.477 3.477 0 0 1 3.472 3.472v13.886z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg400MlE);
export default __webpack_public_path__ + "static/media/400_ml_e.80e78911f3e79036e429f7068a623488.svg";
export { ForwardRef as ReactComponent };